const objectToFormData = (data) => {
    const formData = new FormData();

    Object.keys(data).forEach(key => {
        const { name, value } = data[key];

        if((name && value) && name !== undefined && name !== '')
            formData.append(name, value);
    });

    return formData;
};

export default objectToFormData;
